import { Button, Card, Col, DatePicker, Form, Input, Row, Select, Space, theme } from 'antd';
import { useEffect } from 'react';
import { computeButtonColLayout, filterFormGridLayout, filterFormItemLayout, filterFormItemStyle } from '@utils/property';
import dayjs from 'dayjs';
import './ConferenceFilterPanel.less';

const TOTAL_FIELD_COUNT = 7;

export default function ConferenceFilterPanel({ filter, onFinish, onReset }) {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const buttonColLayout = computeButtonColLayout(TOTAL_FIELD_COUNT);

    useEffect(() => {
        const formValues = { ...filter };
        if (filter.dates && Array.isArray(filter.dates)) {
            try {
                formValues.dates = filter.dates.map(date => (dayjs.isDayjs(date) ? date : dayjs(date)));
            } catch {
                delete formValues.dates;
            }
        }
        form.setFieldsValue(formValues);
    }, [filter, form]);

    const handleReset = () => {
        form.resetFields();
        onReset();
    };

    const handleFinish = values => {
        const newValues = { ...values };
        if (values.dates && values.dates.length === 2) {
            newValues.dates = values.dates;
        } else {
            delete newValues.dates;
        }
        onFinish(newValues);
    };

    return (
        <Card
            size="small"
            className="conference-filter-panel"
            style={{
                marginBottom: token.marginLG,
                border: `1px solid ${token.colorBorderSecondary}`,
                background: token.colorFillAlter,
            }}
        >
            <Form {...filterFormItemLayout} form={form} onFinish={handleFinish} autoComplete="off" requiredMark={false}>
                <Row gutter={[16, 16]}>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="名称" name="name" style={filterFormItemStyle}>
                            <Input allowClear placeholder="会议项目名称关键字" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="会议项目编号" name="idList" style={filterFormItemStyle}>
                            <Input allowClear placeholder="会议项目编号或ID" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="氚云编号" name="h3yunNo" style={filterFormItemStyle}>
                            <Input allowClear placeholder="氚云编号" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="执行日期" name="dates" style={filterFormItemStyle}>
                            <DatePicker.RangePicker style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="创建人" name="createdBy" style={filterFormItemStyle}>
                            <Input allowClear placeholder="项目创建人" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="劳务付款" name="labelPayment" style={filterFormItemStyle}>
                            <Select placeholder="选择是否需要劳务" allowClear>
                                <Select.Option value={0}>无需劳务</Select.Option>
                                <Select.Option value={1}>需要劳务</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="正式/测试" name="isTesting" style={filterFormItemStyle}>
                            <Select placeholder="选择是否测试会议" allowClear>
                                <Select.Option value={0}>正式会议</Select.Option>
                                <Select.Option value={1}>测试会议</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col {...buttonColLayout}>
                        <Form.Item label={<span>&nbsp;</span>} colon={false} style={filterFormItemStyle}>
                            <Space size="small">
                                <Button type="primary" htmlType="submit" icon={<i className="bi bi-search" aria-hidden="true" />}>
                                    检索
                                </Button>
                                <Button type="default" onClick={handleReset}>
                                    重置
                                </Button>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
}
